import BackendService from "./BackendService";

async function getExpenses(params = {}) {
  return BackendService.getData("/expenses/", {}, params);
}
async function createExpense(data) {
  return BackendService.postData("/expenses/", data);
}
async function updateExpense(id, data = {}) {
  return BackendService.put(`/expenses/${id}/`, data);
}
async function deleteExpense(id) {
  return BackendService.destroy(`/expenses/${id}/`, "");
}
async function getExpenseTypes(params = {}) {
  return BackendService.getData("/expense-types/", {}, params);
}

const ExpenseService = {
  getExpenses,
  getExpenseTypes,
  createExpense,
  updateExpense,
  deleteExpense,
};

export default ExpenseService;
